export default __webpack_public_path__ + "static/media/deep-space.defdee4e170764c87f8a19df55069ea0.jpg";